import { types } from 'mobx-state-tree';
import { Amplify, API, Hub, withSSRContext, } from 'aws-amplify';
import { MainModel, setGQLAPI } from './RootModel';
import { S3FileModel } from './S3FileModel';
import { setResolver, } from './Schema';
import { getTimestamp } from './logger';
export const PortalStore = types.compose(S3FileModel, MainModel).named('PortalStore');
let Auth;
const setAuthToken = async (portalStore) => {
    // const currentCreds = await Auth.currentCredentials();
    // console.log('currentCreds', currentCreds);
    console.log('setAuthToken');
    await Auth.currentAuthenticatedUser({ bypassCache: true })
        .then(() => (Auth.currentUserCredentials()))
        .then((credentials) => {
        console.log('identityId', credentials.identityId);
        portalStore.setIdentityId(credentials.identityId);
        return credentials;
    });
};
/**
 * Used to ensure portal session is initialized before doing business functions.
 * Currently includes get the current user and loading the organization and
 * available repositories.  Can be called multiple times - init will only happen once.
 */
export const initPortalSession = async (portalStore) => {
    try {
        await portalStore.getCustomerInfo(true);
        console.log('Got customer info', portalStore);
        if (portalStore.currentPortal && portalStore.currentCustomer) {
            await portalStore.getLearningBoard(portalStore.currentPortal, portalStore.currentCustomer);
        }
    }
    catch (e) {
        console.log('no customer', e);
        portalStore.setAnonymous(true);
    }
};
// gets called from index.tsx to make connection - for portal
export const configureClient = async (config, snapshot) => {
    const awsConfig = { ...config, ssr: true };
    // console.log('Amplify.configure client', {
    //   awsConfig,
    //   snapshot,
    // });
    //
    Amplify.configure(awsConfig);
    Auth = Amplify.Auth;
    setGQLAPI(API);
    const portalStore = PortalStore.create(snapshot);
    setResolver(portalStore);
    console.log('Listening on Hub');
    Hub.listen(/.*/, async (data) => {
        console.log('Hub message: ', data);
        if (data.channel === 'auth') {
            console.log('Auth', data);
            if (data.payload.event === 'configured') {
                console.log('Auth Configured Event');
            }
            else if (data.payload.event === 'tokenRefresh') {
                console.log('Token Refresh');
                // await initPortalSession(portalStore);
            }
            else if (data.payload.event === 'signIn') {
                console.log('Sign In');
                await initPortalSession(portalStore);
                await portalStore.refreshCognito();
            }
        }
    });
    try {
        await setAuthToken(portalStore);
        await initPortalSession(portalStore);
    }
    catch (e) {
        console.log('no customer', e);
        portalStore.setAnonymous(true);
    }
    return portalStore;
};
const defaultSnapshot = {
    isPortalApi: true,
    isAnonymous: false,
    amplifyEnvironment: '',
    status: 'not_loaded',
    repositories: {},
    categories: {},
    programs: {},
    courses: {},
    notes: {},
    state: 'done',
    fileState: 'done',
};
const loadCustomer = async (portalStore) => {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        // const currentCreds = await Auth.currentCredentials();
        // console.log(`${getTimestamp()} currentCreds`, currentCreds);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        // const userPoolUser = await Auth.currentUserPoolUser();
        // console.log(`${getTimestamp()} user pool user`, userPoolUser.username);
        // const cognitoUser = await Auth.currentAuthenticatedUser();
        // console.log(`${getTimestamp()} cog user`, cognitoUser.username);
        await portalStore.getCustomerInfo(true);
        console.log(`${getTimestamp()} customerInfo complete`);
    }
    catch (e) {
        console.log('Did not get customer info - setting anonymous');
        portalStore.setAnonymous(true);
    }
};
// gets called from index.tsx to make connection
export const configureServer = async (awsExports, organizationId, portalId, req, snapshot) => {
    console.log(`${getTimestamp()} Configure portal: ${portalId} with organization: ${organizationId}`);
    const ssrConfig = { ...awsExports, ssr: true };
    Amplify.configure(ssrConfig);
    const SSR = withSSRContext({ req });
    Auth = SSR.Auth;
    setGQLAPI(SSR.API);
    // console.log(`${getTimestamp()} amplify setup`);
    const portalStore = PortalStore.create(snapshot || defaultSnapshot);
    console.log('process.env', process.env);
    const amplifyEnvironment = typeof process !== 'undefined' ? process.env.ENV?.trim() : '';
    if (amplifyEnvironment) {
        portalStore.setAmplifyEnvironment(amplifyEnvironment);
    }
    else {
        throw new Error('Amplify environment is not set');
    }
    setResolver(portalStore);
    // doing this first so currentOrganization is set when other items are loaded
    const tempOrganization = portalStore.getOrLoad('organization', organizationId);
    await portalStore.setCurrentOrganization(tempOrganization);
    // console.log(`${getTimestamp()} portalStore ready`);
    await Promise.allSettled([
        portalStore.load('organization', organizationId),
        portalStore.load('portal', `${organizationId}~${portalId}`),
        loadCustomer(portalStore),
    ]);
    await Promise.allSettled(portalStore.currentPortal?.libraryShares?.map((libraryShare) => portalStore.load('libraryShare', libraryShare.id)));
    // console.log(`${getTimestamp()} org`, getSnapshot(organization));
    // console.log(`${getTimestamp()} portal`, getSnapshot(portal));
    // console.log(`${getTimestamp()} setCurrentPortalComplete`);
    return portalStore;
};
//# sourceMappingURL=PortalStore.js.map